module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.podskupine.length == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.subgroups.emptySubgroup')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.podskupine
    },
    on: {
      "update": function($event) {
        return _vm.posodobi()
      }
    }
  }, _vm._l((_vm.podskupine), function(podskupina) {
    return _c('li', {
      key: podskupina.id,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row my-margin"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("pickTranslation")(podskupina.name)))])])])])
  }), 0)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03961941", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03961941"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/ReorderSubgroups.vue
// module id = 1407
// module chunks = 1